// sagas/authSaga.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { msalInstance, getAccessTokenForGraph } from '../utils/auth';
import {
  initialUserDataState,
  setUserData,
} from '~/GlobalRedux/Features/userData/userDataSlice';

interface GraphData {
  id: string;
  displayName: string;
  mail: string;
  userPrincipalName: string;
  // Adicione outros campos conforme necessário
}

function* fetchGraphData(accessToken: string): SagaIterator<GraphData> {
  const response = yield call(fetch, 'https://graph.microsoft.com/v1.0/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const data: GraphData = yield call([response, response.json]);
  return data;
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function* fetchProfilePhoto(accessToken: string): SagaIterator<string> {
  const response = yield call(
    fetch,
    'https://graph.microsoft.com/v1.0/me/photo/$value',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  const blob: Blob = yield call([response, response.blob]);
  const base64String: string = yield call(blobToBase64, blob);
  return base64String;
}

function* login(_action: AnyAction): SagaIterator<void> {
  console.log('login iniciado');
  if (msalInstance) yield call([msalInstance, msalInstance.loginPopup]);
  console.log('before access token');
  const accessToken: string = yield call(getAccessTokenForGraph);
  console.log('access token', accessToken);
  const graphData: GraphData = yield call(fetchGraphData, accessToken);
  console.log('graph data: ', graphData);
  const photoBase64: string = yield call(fetchProfilePhoto, accessToken);
  console.log('photo base 64: ', photoBase64);

  // Mapeia os dados do Graph para o formato UserDataState
  const userData = {
    id: graphData.id,
    name: graphData.displayName,
    email: graphData.mail || graphData.userPrincipalName,
    photo: photoBase64,
  };

  yield put(setUserData(userData));
  window.location.replace('/dashboard');
}

export default function* authSaga(): SagaIterator<void> {
  yield takeLatest('LOGIN_REQUEST', login);
  yield takeLatest('LOGOUT_REQUEST', logout);
}

function* logout(_action: AnyAction): SagaIterator<void> {
  if (msalInstance) {
    yield call([msalInstance, msalInstance.logout]);
    localStorage.clear();
    sessionStorage.clear();
  }
  // Limpa os dados do usuário
  yield put(setUserData(initialUserDataState));
  window.location.replace('/login');
}
